import { render } from "./TextareaWithClear.vue?vue&type=template&id=11bc86d6&scoped=true"
import script from "./TextareaWithClear.vue?vue&type=script&lang=js"
export * from "./TextareaWithClear.vue?vue&type=script&lang=js"

import "./TextareaWithClear.vue?vue&type=style&index=0&id=11bc86d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bc86d6"]])

export default __exports__